const RAD = Math.PI / 180;

// NOAA solar approximation; defaults to Rome (clinic in Italy).
export function isAfterSunset(date = new Date(), lat = 41.9, lon = 12.5) {
  const start = Date.UTC(date.getUTCFullYear(), 0, 1);
  const n = Math.floor((date.getTime() - start) / 86400000) + 1;
  const g = ((2 * Math.PI) / 365) * (n - 1);
  const eq = 229.18 * (0.000075 + 0.001868 * Math.cos(g) - 0.032077 * Math.sin(g) - 0.014615 * Math.cos(2 * g) - 0.040849 * Math.sin(2 * g));
  const decl = 0.006918 - 0.399912 * Math.cos(g) + 0.070257 * Math.sin(g) - 0.006758 * Math.cos(2 * g)
    + 0.000907 * Math.sin(2 * g) - 0.002697 * Math.cos(3 * g) + 0.00148 * Math.sin(3 * g);
  const ha = Math.acos(Math.cos(90.833 * RAD) / (Math.cos(lat * RAD) * Math.cos(decl)) - Math.tan(lat * RAD) * Math.tan(decl)) / RAD;
  const sunrise = 720 - 4 * (lon + ha) - eq;
  const sunset = 720 - 4 * (lon - ha) - eq;
  const nowMin = date.getUTCHours() * 60 + date.getUTCMinutes();
  return nowMin >= sunset || nowMin < sunrise;
}

export function heroVariant() {
  const q = new URLSearchParams(window.location.search);
  if (q.has("sera")) return "-night";
  if (q.has("giorno")) return "";
  return isAfterSunset() ? "-night" : "";
}
